module.exports = __webpack_public_path__ + "img/stock6.a3447ab1.png";